import RailCarousel from "@/components/RailCarousel";
import useCurrentUserDietaryRequirements from "@/hooks/useCurrentUserDietaryRequirements";
import { observer } from "mobx-react";
import { useMemo } from "react";

const FilteredEditorialRail = observer(
  ({
    rail,
    className = "",
    theme = "dark",
    showHeading = true,
    showChef = true,
    showSection = true,
    showSummary = false,
  }) => {
    const { dietaryRequirementIds } = useCurrentUserDietaryRequirements();

    // Filter recipes based on user's dietary requirements
    const filteredRecipes = useMemo(() => {
      // If user has no dietary requirements, return all recipes
      if (!dietaryRequirementIds?.length) {
        return rail.recipes || [];
      }

      // Filter recipes that have at least one dietary requirement that matches user's requirements
      return (rail.recipes || []).filter((recipe) => {
        // If recipe has no dietary requirements, it cannot be eaten by users with dietary restrictions
        if (!recipe.dietaryRequirements?.length) {
          return false;
        }

        // Check if any of the recipe's dietary requirements match the user's requirements
        return recipe.dietaryRequirements.some((recipeDietary) => {
          return dietaryRequirementIds.includes(recipeDietary.id);
        });
      });
    }, [rail.recipes, dietaryRequirementIds]);

    // If no recipes match the dietary requirements, don't render the rail
    if (dietaryRequirementIds?.length && filteredRecipes.length === 0) {
      return null;
    }

    return (
      <RailCarousel
        entries={filteredRecipes}
        heading={rail.frontendTitle ?? rail.title}
        summary={rail.summary}
        theme={theme}
        className={className}
        showHeading={showHeading}
        showChef={showChef}
        showSection={showSection}
        showSummary={showSummary}
        railId={rail.id}
      />
    );
  }
);

export default FilteredEditorialRail;
